var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import * as React from 'react';
import { CheckboxGroupControlled } from './CheckboxGroupControlled';
export const CheckboxGroupUncontrolled = (_a) => {
    var { defaultValue, onChange } = _a, props = __rest(_a, ["defaultValue", "onChange"]);
    const [value, setValue] = React.useState(defaultValue || []);
    const handleChange = event => {
        const { target } = event;
        if (value.includes(target.value)) {
            setValue(value.filter(v => v !== target.value));
        }
        else {
            setValue([...value, target.value]);
        }
        if (onChange)
            onChange(event);
    };
    return (_jsx(CheckboxGroupControlled, Object.assign({}, props, { value: value, defaultValue: undefined, onChange: handleChange })));
};
